import React, {useState, useEffect, Suspense, lazy} from 'react';
import {Button, Table, Row, message, Popconfirm, Typography} from 'antd';
import {getApiWithAuthToken} from '../../../api';
import {useColumnSearchProps, handleDeleteClick, handleTableChange} from '../../../helpers/table';
import ProtectedComponent from '../../ProtectedComponent';
const ProductCategoryForm = lazy(() => import('./ProductCategoryForm'));

const ProductCategory = () => {
  // Table states
  const [loading, setLoading] = useState(true);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [queryParams, setQueryParams] = useState({
    limit: 10,
    page: 1,
    name: null,
    code: null,
    ref_code: null,
    field: null,
    order: null,
  });

  const getProductCategoryList = (qp = queryParams) => {
    setLoading(true);
    getApiWithAuthToken(
      `/api/v1/admin/productCategories?limit=${qp.limit}&page=${qp.page}` +
        (qp.name ? `&name=${qp.name}` : '') +
        (qp.code ? `&code=${qp.code}` : '') +
        (qp.ref_code ? `&ref_code=${qp.ref_code}` : '') +
        (qp.field ? `&field=${qp.field}` : '') +
        (qp.order ? `&order=${qp.order}` : '')
    ).then(res => {
      if (!res.error && res.data.productCategories.length) {
        setTotalCount(res.data.total_count);
        setProductCategoryList(
          res.data.productCategories.map(each => ({
            id: each.id,
            code: each.code,
            name: each.name,
            ref_code: each.ref_code,
          }))
        );
      } else {
        if (res.errors) {
          Object.values(res.errors).map(each => message.error(each.msg));
        } else {
          message.error({content: 'Network Error!'});
        }
        setProductCategoryList([]);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getProductCategoryList(queryParams);
  }, []);

  // Edit function

  const [selectedProductCategory, setSelectedProductCategory] = useState({});
  const handleEditClick = record => {
    setSelectedProductCategory(record);
    setIsDrawerVisible(true);
  };

  //Drawer Open function
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const showDrawer = () => {
    setSelectedProductCategory({});
    setIsDrawerVisible(true);
  };
  const handleDrawerClose = () => {
    setIsDrawerVisible(false);
  };

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      ...useColumnSearchProps('code', queryParams, setQueryParams, getProductCategoryList),
      sorter: true,
    },
    {
      title: 'Ref Code',
      dataIndex: 'ref_code',
      key: 'ref_code',
      ...useColumnSearchProps('ref_code', queryParams, setQueryParams, getProductCategoryList),
      sorter: true,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ...useColumnSearchProps('name', queryParams, setQueryParams, getProductCategoryList),
      sorter: true,
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'right',
      render: (_, record) => (
        <>
          <ProtectedComponent permissionName="Product" actionName="update">
            <Button size="small" onClick={() => handleEditClick(record)}>
              Edit
            </Button>
          </ProtectedComponent>
          <span> </span>
          <ProtectedComponent permissionName="Product" actionName="delete">
            <Popconfirm
              title="Are you sure to delete this product category?"
              onConfirm={() =>
                handleDeleteClick(record.id, '/api/v1/admin/productCategories/', () =>
                  getProductCategoryList(queryParams)
                )
              }
            >
              <Button danger size="small">
                Delete
              </Button>
            </Popconfirm>
          </ProtectedComponent>
        </>
      ),
    },
  ];

  return (
    <>
      <Row justify="space-between" style={{margin: '24px 0'}}>
        <Typography.Title level={3} style={{marginBottom: '0'}}>
          Product Category
        </Typography.Title>
        <ProtectedComponent permissionName="Product" actionName="create">
          <Button type="primary" onClick={showDrawer}>
            Add
          </Button>
        </ProtectedComponent>
      </Row>
      <ProtectedComponent permissionName="Product" actionName="read">
        <Table
          scroll={{x: 0}}
          dataSource={productCategoryList}
          columns={columns}
          loading={loading}
          onChange={handleTableChange(queryParams, setQueryParams, getProductCategoryList)}
          pagination={{
            showSizeChanger: true,
            total: totalCount,
            current: queryParams.page,
            pageSize: queryParams.limit,
            size: 'default',
            showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} items`,
          }}
        />
      </ProtectedComponent>
<Suspense fallback={'Loading...'}>
      <ProductCategoryForm
        handleDrawerClose={handleDrawerClose}
        isDrawerVisible={isDrawerVisible}
        getProductCategoryList={getProductCategoryList}
        productCategory={selectedProductCategory}
      />
</Suspense>
    </>
  );
};

export default ProductCategory;
